interface ProfileProps {
  userName?: string;
  className?: string;
}

const Profile = ({ userName, className }: ProfileProps) => {
  return (
    userName && (
      <div className={`${className}`}>
        <h2>Hi, {userName}</h2>
      </div>
    )
  );
};

export default Profile;
